import {Component, OnInit, Input, Optional, Self} from '@angular/core';
import {FormGroup, NgControl} from '@angular/forms';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";
import { ComparableOperator, PosibleAnswer } from '@app/models/form';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss']
})
export class TextInputComponent extends BaseAnswerTypeComponent<string> implements OnInit {
  @Input() maxLength: number = 200;
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() inputType: 'text' | 'email' | 'number' = 'text';


  constructor(@Optional() @Self() ngControl?: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
  }

  AllowedOperators: {[K in ComparableOperator]: (t: string, value: string) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (target: string) => !target,
    [ComparableOperator.NotIsNullOrEmpty]: (target: string, value) => !!target,
    [ComparableOperator.Between]: null,
  }

}
